import { db } from "../../FirebaseConfig";
import { collection, addDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// Function to add a new article to Firestore
export const addArticleToFirestore = async (article) => {
  try {
    const docRef = await addDoc(collection(db, "articles"), article);
    console.log("Document written with ID: ", docRef.id);
    return docRef.id;
  } catch (error) {
    console.error("Error adding document: ", error);
    throw new Error("Failed to add article to Firestore");
  }
};

// Function to upload an image to Firebase Storage
export const uploadImageToFirebase = async (imageFile) => {
  try {
    const storage = getStorage();
    const imageRef = ref(storage, `article-images/${Date.now()}-${imageFile.name}`);
    const snapshot = await uploadBytes(imageRef, imageFile);
    const downloadURL = await getDownloadURL(snapshot.ref);
    console.log("Image uploaded to Firebase Storage, URL: ", downloadURL);
    return downloadURL;
  } catch (error) {
    console.error("Error uploading image: ", error);
    throw new Error("Failed to upload image to Firebase Storage");
  }
};
